// The studio's popovers (the products, the models) open upward over the composer, as live's do,
// and take the room above their anchor: never flipped under it, clear of the app's header. One
// near the top of a dialog (the Generate image dialog's models, #598) opens downward instead, as
// the header's gift menu does (spec web/achievements, decision 21).
import type { PopoverProps } from "@mantine/core";

/** The popover keeps clear of the app's header above and of the window's other edges. */
const ROOM_PADDING = { top: 72, right: 16, bottom: 16, left: 16 };

/** Tells the popover's content the height above its anchor, as `--picker-room`. */
function fitRoom(state: { availableHeight: number; elements: { floating: HTMLElement } }) {
  state.elements.floating.style.setProperty("--picker-room", `${state.availableHeight}px`);
}

/** Mantine's `middlewares` for such a popover; its content reads `var(--picker-room)`. */
export const ROOM_ABOVE: NonNullable<PopoverProps["middlewares"]> = {
  flip: false,
  shift: true,
  size: { padding: ROOM_PADDING, apply: fitRoom },
};

/** The same, for a popover that opens under its anchor: the room below it, as `--picker-room`. */
export const ROOM_BELOW: NonNullable<PopoverProps["middlewares"]> = {
  flip: false,
  shift: true,
  size: { padding: { top: 16, right: 16, bottom: 16, left: 16 }, apply: fitRoom },
};

/**
 * For a popover under an anchor that may sit anywhere on a long page (a member's achievements, spec
 * web/achievements, decision 23): over it where the room there is bigger, and the room on its side
 * as `--picker-room`.
 */
export const ROOM_EITHER: NonNullable<PopoverProps["middlewares"]> = {
  flip: true,
  shift: true,
  size: { padding: ROOM_PADDING, apply: fitRoom },
};
